// Обновление установленного приложения.
//
// Разбор жалобы 3 сентября 2026: «веб-приложение перестало распознавать любую
// еду, в телеграме работает». Сервер в это время отвечал всем — распознавания
// шли, ошибок прокси не было ни одной. У человека в PWA застряла сборка
// трёхнедельной давности, где жила опечатка в auth-store: она превращала
// каждый успешный ответ распознавания в ошибку. Помогла переустановка через
// Safari, то есть свежий бандл.
//
// Застревать он мог долго. Service worker обновляется сам (registerType
// 'autoUpdate', в sw.js есть skipWaiting и clientsClaim), но уже открытая
// страница продолжает исполнять старый JS из памяти: свежие файлы применяются
// только при перезагрузке документа. PWA на iOS в standalone живёт в фоне
// неделями и такой перезагрузки может не получить вовсе.
//
// Поэтому перезагружаем сами — при возврате из фона, но только когда человек
// ничего не заполняет. До 14.10.2026 этот момент считался безопасным всегда,
// а на деле люди сворачивали Зою посреди ввода (скопировать состав, ответить
// в мессенджере), возвращались — и получали пустой экран вместо набранного
// приёма: деплоев в день бывает десяток, и флаг «перезагрузить» почти всегда
// взведён. Теперь перезагрузка ждёт, пока реестр незаконченного ввода
// (services/unsaved.js) опустеет, и срабатывает при следующем возврате.

import { hasUnsaved } from '../services/unsaved.js'

const CHECK_EVERY_MS = 30 * 60 * 1000

export function initAppUpdate() {
  if (!('serviceWorker' in navigator)) return

  // Была ли страница под управлением воркера в момент запуска. Первая
  // установка тоже поднимает controllerchange, и без этой отметки самый
  // первый визит заканчивался бы перезагрузкой на ровном месте.
  const hadController = !!navigator.serviceWorker.controller
  let pendingReload = false
  let lastCheck = 0

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) pendingReload = true
  })

  async function check() {
    lastCheck = Date.now()
    try {
      const reg = await navigator.serviceWorker.getRegistration()
      await reg?.update()
    } catch {
      // Проверка обновления не имеет права ломать сценарий: не вышло — не вышло.
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return
    if (pendingReload) {
      // Открыто окно добавления, форма продукта или набран текст — не сейчас.
      // Флаг остаётся, перезагрузка случится при следующем возврате без них.
      if (hasUnsaved()) return
      window.location.reload()
      return
    }
    if (Date.now() - lastCheck > CHECK_EVERY_MS) check()
  })

  check()
}
